import { LabelQuestionConfig } from '@gripp/shared-logic';
import { OptionList, RuledLines } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const LabelPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const label = config as LabelQuestionConfig;
  const labels = label.labels ?? [];

  // Label questions usually carry no fixed choice list -- the picker is filled
  // from the workspace's labels at execution time -- so the printed form gives
  // a writable line instead of an empty box.
  if (labels.length === 0) return <RuledLines />;

  return <OptionList options={labels.map((entry) => entry.name)} glyph="check" />;
};
